import Flickity from "flickity";
import "flickity/css/flickity.css";

(function (Drupal) {
  Drupal.behaviors.useFlickityOtherServices = {
    attach: function (context, settings) {
      const flickityContainers = document.querySelectorAll(".useflickity--other-services .view-content");

      const deviceDetect = {
        breakpointDesktop: 992,
        isMobile: () => {
          return window.matchMedia(`(min-width: ${deviceDetect.breakpointDesktop}px)`).matches;
        },
      };
      if (deviceDetect.isMobile()) {
        if (!flickityContainers) return;

        flickityContainers.forEach((container) => {
          const elementos = container.querySelectorAll('.views-row');
          if (elementos.length > 3) {
            new Flickity(container, {
              cellAlign: "left",
              contain: true,
              groupCells: true,
            });
          } else {
            container.classList.add("not-slider")
          }
        });
      }
    },
  };
})(Drupal);
